import React from "react";
import ButtonIcon from "Components/buttonIcon/ButtonIcon";
import cx from "classnames";
import { refresh } from "Icons/index";

const ButtonRefresh = ({ isLoading, onClick }) => {
  return (
    <ButtonIcon
      className={cx({ ["isRefreshing"]: isLoading })}
      icon={refresh}
      onClick={isLoading ? () => {} : onClick}
    />
  );
};

export default ButtonRefresh;
